import { create } from "../../../../../common/utils/zustand_state_manager";
import {
  SetFunction,
  SetFunctionImpl,
} from "../../../../../common/utils/filters_utils";

type State = {
  IdAuditor: number;
  tipoPesquisa: number;
  pesquisa: string;
  tipoAuditor: number;
};

type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
  setTipoPesquisa: SetFunction<number>;
  setPesquisa: SetFunction<string>;
  setTipoAuditor: SetFunction<number>;
};

export const initialFiltersValues: State = {
  IdAuditor: 0,
  tipoPesquisa: 0,
  pesquisa: "",
  tipoAuditor: 2,
};

export const useAuditoresFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setTipoPesquisa: (vfn) => SetFunctionImpl(set, "tipoPesquisa", vfn),
  setPesquisa: (vfn) => SetFunctionImpl(set, "pesquisa", vfn),
  setTipoAuditor: (vfn) => SetFunctionImpl(set, "tipoAuditor", vfn),
  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set(initialFiltersValues),
}));
